var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10643_27332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.531 7.28104L9.53104 19.281C9.46139 19.3508 9.37867 19.4061 9.28762 19.4438C9.19657 19.4816 9.09898 19.501 9.00042 19.501C8.90186 19.501 8.80426 19.4816 8.71321 19.4438C8.62216 19.4061 8.53945 19.3508 8.46979 19.281L3.21979 14.031C3.07906 13.8903 3 13.6994 3 13.5004C3 13.3014 3.07906 13.1105 3.21979 12.9698C3.36052 12.8291 3.55139 12.75 3.75042 12.75C3.94944 12.75 4.14031 12.8291 4.28104 12.9698L9.00042 17.6901L20.4698 6.21979C20.6105 6.07906 20.8014 6 21.0004 6C21.1994 6 21.3903 6.07906 21.531 6.21979C21.6718 6.36052 21.7508 6.55139 21.7508 6.75042C21.7508 6.94944 21.6718 7.14031 21.531 7.28104Z",
    fill: "#4CAF50"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10643_27332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOk);
export default __webpack_public_path__ + "static/media/ok.c4c71db84ef1b32f953fd83b1b789321.svg";
export { ForwardRef as ReactComponent };